export function getAssetPath() {
	return process.env.REACT_APP_ASSET_URL + "/assets/";
}

const assetPath = getAssetPath();
export default assetPath;
